import React from 'react';

export function AcademicReferralsDescription(): JSX.Element {
  return (
    <div>
      <div className="legacy-font-proxima-27">
        Love Benchling? Refer your colleagues to earn extra space and access to an enterprise feature
      </div>
      <div className="u-spacing-top invitePage-description">
        When five of your referrals sign up, receive <strong>Benchling Gold</strong> status! You'll get:
        <ul>
          <li>15 GB of extra space</li>
          <li>
            Benchling Sync, a feature that allows you to open an attachment in its desktop application and
            automatically syncs edits to your notebook
          </li>
        </ul>
      </div>
    </div>
  );
}
